import {useState} from "react";
import BookingService from "../services/api";
import {useSnackbar} from "notistack";
import {useNavigate} from "react-router-dom";
import useBookingStore from "../zustand/useBookingStore";

const useBooking = () => {
    const {enqueueSnackbar} = useSnackbar();
    const navigate = useNavigate();

    const {setBookingStatusUpdated} = useBookingStore();

    const [isFetchingBookingList, setFetchingBookingList] = useState(false);
    const [bookingListData, setBookingListData] = useState([]);
    const [isFetchingBookingDetails, setFetchingBookingDetails] = useState(false);
    const [bookingDetailsData, setBookingDetailsData] = useState(null);
    const [isCreatingBooking, setCreatingBooking] = useState(false);
    const [isUpdatingBooking, setUpdatingBooking] = useState(false);
    const [isFetchingBookingTypes, setFetchingBookingTypes] = useState(false);
    const [bookingTypes, setBookingTypes] = useState(null);
    const [isUpdatingBookingStatus, setUpdatingBookingStatus] = useState(false);
    const [isFetchingBookingStatusList, setFetchingBookingStatusList] = useState(false);
    const [bookingStatusList, setBookingStatusList] = useState([]);
    const [isFilteringBooking, setFilteringBooking] = useState(false);


    const listBooking = (parameters) => {
        setFetchingBookingList(true);
        setBookingStatusUpdated(false);

        BookingService.listBooking(parameters).then((res) => {
            console.log("listBooking data xxxx", res);

            if (res.data.success) {
                setFetchingBookingList(false);
                setBookingListData(res.data.data);
            } 

        }).catch((error) => {
            console.error("Error fetching booking list:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setBookingListData([]);
            setFetchingBookingList(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const viewBooking = (parameters) => {
        setFetchingBookingDetails(true);

        BookingService.viewBooking(parameters).then((res) => {
            console.log("viewBooking data xxxx", res);

            if (res.data.success) {
                setFetchingBookingDetails(false);
                setBookingDetailsData(res.data.data);
            } 

        }).catch((error) => {
            console.error("Error fetching booking details:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setBookingDetailsData([]);
            setFetchingBookingDetails(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const createBooking = (payload, orgIdFromUrlForPortEmployee) => {
        setCreatingBooking(true);

        BookingService.createBooking(payload).then((res) => {
            console.log("createBooking data xxxx", res);

            if (res.data.success) {
                setCreatingBooking(false);
                enqueueSnackbar("Successfully created booking request", {
                    variant: "success",
                    autoHideDuration: 3500
                });

                if (orgIdFromUrlForPortEmployee) {
                    navigate(`/organization/view/bookings/view?org_uid=${res.data.data.org_uid}&id=${res.data.data.booking_uid}`);

                } else {
                    navigate(`/bookings/view?id=${res.data.data.booking_uid}`);
                }
            } 

        }).catch((error) => {
            console.error("Error creating booking:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setCreatingBooking(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const updateBooking = (parameters, payload, orgIdFromUrlForPortEmployee) => {
        setUpdatingBooking(true);

        BookingService.updateBooking(parameters, payload).then((res) => {
            console.log("updateBooking data xxxx", res);

            if (res.data.success) {
                setUpdatingBooking(false);
                enqueueSnackbar("Successfully updated booking request", {
                    variant: "success",
                    autoHideDuration: 3500
                });

                if (orgIdFromUrlForPortEmployee) {
                    navigate(`/organization/view/bookings/view?org_uid=${res.data.data.org_uid}&id=${res.data.data.booking_uid}`);

                } else {
                    navigate(`/bookings/view?id=${res.data.data.booking_uid}`);
                }
            } 

        }).catch((error) => {
            console.error("Error updating booking:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setUpdatingBooking(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const getBookingTypes = () => {
        setFetchingBookingTypes(true);

        BookingService.getBookingTypes().then((res) => {
            console.log("getBookingTypes data xxxx", res);

            if (res.data.success) {
                setFetchingBookingTypes(false);
                setBookingTypes(res.data.data);
            } 

        }).catch((error) => {
            console.error("Error fetching booking types:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setBookingTypes(null);
            setFetchingBookingTypes(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const updateBookingStatus = (parameters) => {
        setUpdatingBookingStatus(true);

        BookingService.updateBookingStatus(parameters).then((res) => {
            console.log("updateBookingStatus data xxxx", res);

            if (res.data.success) {
                setUpdatingBookingStatus(false);
                setBookingStatusUpdated(true);

                enqueueSnackbar("Successfully updated booking status", {
                    variant: "success",
                    autoHideDuration: 3500
                });
            } 

        }).catch((error) => {
            console.error("Error updating booking status:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setBookingStatusUpdated(false);
            setUpdatingBookingStatus(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const getBookingStatusList = () => {
        setFetchingBookingStatusList(true);

        BookingService.getBookingStatusList().then((res) => {
            console.log("getBookingStatusList data xxxx", res);

            if (res.data.success) {
                setFetchingBookingStatusList(false);
                setBookingStatusList(res.data.data);
            } 

        }).catch((error) => {
            console.error("Error fetching booking status list:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setBookingStatusList(null);
            setFetchingBookingStatusList(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const filterBooking = (parameters) => {
        setFilteringBooking(true);

        BookingService.filterBooking(parameters).then((res) => {
            console.log("filterBooking data xxxx", res);

            if (res.data.success) {
                setFilteringBooking(false);
                setBookingListData(res.data.data);
            } 

        }).catch((error) => {
            console.error("Error filtering booking list:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setBookingListData(null);
            setFilteringBooking(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }


    return {
        isFetchingBookingList,
        bookingListData,
        listBooking,

        isFetchingBookingDetails,
        bookingDetailsData,
        viewBooking,

        isCreatingBooking,
        createBooking,

        isUpdatingBooking,
        updateBooking,

        isFetchingBookingTypes,
        bookingTypes,
        getBookingTypes,

        isUpdatingBookingStatus,
        updateBookingStatus,

        isFetchingBookingStatusList,
        bookingStatusList,
        getBookingStatusList,

        isFilteringBooking,
        filterBooking
    }
}

export default useBooking